import { isGuestInfoExists } from '@extranet-ts/pages/approve/[token]/model/book_guest';
import * as React from 'react';
import { useMemo } from 'react';
import { Flex } from '../../../../../components/common/flex';
import { StatusLabel } from '../../../../../components/common/status_label';
import { IBookInfoProps } from './book_info.d';

export const BookInfo: React.FC<IBookInfoProps> = ({ book }) => {
  const allGuests = useMemo(() => {
    if (!book || !Array.isArray(book.all_guests) || !book.all_guests.length) return [];

    return book.all_guests.filter(isGuestInfoExists);
  }, [book]);

  return (
    <Flex vertical className={'approve-book-section'}>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Объект</div>
        <div className={'item-row__text'}>{book.camp_name}</div>
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Номер заявки</div>
        <div className={'item-row__text'}>{book.id}</div>
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Статус</div>
        <StatusLabel color={'blue'} statusName={book.status_name} />
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Период проживания</div>
        <Flex vertical gap={2}>
          <div className={'item-row__text'}>{book.dates_period}</div>
          <div className={'item-row__text'}>{book.nights_count_str}</div>
        </Flex>
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Бронирование на имя</div>
        <div className={'item-row__text'}>{book.client_name}</div>
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Все гости</div>
        {allGuests.length ? (
          allGuests.map((guest, index) => (
            <div className={'item-row__text'} key={index}>
              {guest.full_name} {guest.birthday}
            </div>
          ))
        ) : (
          <div className={'item-row__text'}>Имена гостей неизвестны</div>
        )}
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Количество гостей</div>
        <div className={'item-row__text'}>{book.guests_str}</div>
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Предполагаемое время прибытия</div>
        <div className={'item-row__text'}>{book.arrival_time ? book.arrival_time : 'Не указано'}</div>
      </Flex>
      {book.pets_info && (
        <Flex vertical align={'start'} className={'item-row'}>
          <div className={'item-row__title'}>Питомцы</div>
          <div className={'item-row__text'}>{book.pets_info}</div>
        </Flex>
      )}
      {book.client_special_requests && (
        <Flex vertical align={'start'} className={'item-row'}>
          <div className={'item-row__title'}>Пожелания гостей</div>
          <div className={'item-row__text'}>{book.client_special_requests}</div>
        </Flex>
      )}
    </Flex>
  );
};
